import * as Scrivito from "scrivito";
import FormPageWidget from "./FormPageWidget/FormPageWidgetClass";
import IntroPageWidget from "./IntroPageWidget/IntroPageWidgetClass";
import OutroPageWidget from "./OutroPageWidget/OutroPageWidgetClass";

Scrivito.provideEditingConfig("FormWidget", {
  title: "Form Widget",
  hideInSelectionDialogs: false,
  attributes: {
    introPage: {
      title: "Intro Page",
      description: "This page will be displayed as a first page of the form",
    },
    formPages: {
      title: "Form Pages",
    },
    outroPage: {
      title: "Outro Page",
      description: "This page will be displayed as a last page of the form",
    },
    emailCSVReceiver: {
      title: "Email address of receiver",
      description: "This is the email to which CSV file will be sent",
    },
    emailTitle: {
      title: "Email subject",
      description: "Title of the email sent to a filler of this form",
    },
    confirmationEmailText: {
      title: "Text will be send as confirmation email",
    },
  },
  properties: [
    "emailCSVReceiver",
    "emailTitle",
    "confirmationEmailText",
    "introPage",
    "formPages",
    "outroPage",
  ],
  initialContent: {
    emailTitle: "Anfrage über Kontaktformular",
    confirmationEmailText:
      "<p>Vielen Dank für Ihr Interesse. Ihre Anfrage wird bearbeitet.</p>",
    introPage: [new IntroPageWidget()],
    formPages: [new FormPageWidget()],
    outroPage: [new OutroPageWidget()],
  },
  validations: [
    [
      "formPages",
      (_values, { widget }) => {
        const widgets = widget.widgets();
        const receiver = widgets.filter(
          (item) => item.objClass() === "ReceiverEmailInputWidget"
        );
        if (!receiver || receiver.length === 0) {
          return {
            message:
              "You should add receiver email as form input element. If you don't define one internet user will not receive confirmation emails.",
            severity: "warning",
          };
        }
        if (receiver.length > 1) {
          return {
            message:
              "You have defined more than one email receiver input element",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "emailTitle",
      (text) => {
        if (!text) {
          return "this field is required";
        }
        return null;
      },
    ],
    [
      "emailCSVReceiver",
      (text) => {
        if (!text) {
          return "this field is required";
        }
        if (text.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) === null) {
          return "this field must be a valid email address";
        }
        return null;
      },
    ],
  ],
});
